<template v-if="contents.totalCount > 1">
  <div class="hidden md:flex justify-between w-full mt-2">
    <Btn
      v-if="props.content.nextPrevSlug?.prevSlug"
      :color="BtnColor.SECONDARY"
      :size="BtnSize.LG"
      class="flex gap-2"
      :to="`/${hubSlug}/${props.content.nextPrevSlug.prevSlug}`"
    >
      <icon :icon="ArrowLeftCircleSvg" :size="IconSize.SM" />
      {{ $t('common.previous') }}
    </Btn>
    <Btn
      v-if="props.content.nextPrevSlug?.nextSlug"
      :color="BtnColor.SECONDARY"
      :size="BtnSize.LG"
      class="flex gap-2"
      :to="`/${hubSlug}/${props.content.nextPrevSlug?.nextSlug}`"
    >
      {{ $t('common.next') }}
      <icon :icon="ArrowRightCircleSvg" :size="IconSize.SM" />
    </Btn>
  </div>
  <div
    class="md:hidden flex gap-2 fixed bottom-0 left-0 bg-surface w-full px-5 py-3 z-40"
  >
    <Btn
      v-if="props.content.nextPrevSlug?.prevSlug"
      :variant="BtnVariant.OUTLINED"
      :color="BtnColor.SECONDARY"
      :size="BtnSize.LG"
      class="flex gap-2 w-full"
      :to="`/${hubSlug}/${props.content.nextPrevSlug.prevSlug}`"
    >
      <icon :icon="ArrowLeftCircleSvg" :size="IconSize.SM" />
      {{ $t('common.previous') }}
    </Btn>
    <Btn
      v-if="props.content.nextPrevSlug?.nextSlug"
      :variant="BtnVariant.OUTLINED"
      :color="BtnColor.SECONDARY"
      :size="BtnSize.LG"
      class="flex gap-2 w-full"
      :to="`/${hubSlug}/${props.content.nextPrevSlug.nextSlug}`"
    >
      {{ $t('common.next') }}
      <icon :icon="ArrowRightCircleSvg" :size="IconSize.SM" />
    </Btn>
  </div>
</template>
<script lang="ts" setup>
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import ArrowLeftCircleSvg from '~/assets/icons/arrow-left-circle.svg';
import ArrowRightCircleSvg from '~/assets/icons/arrow-right-circle.svg';
import { Icon, IconSize } from '~/components/icon';
import { apiGetContentsList, ContentDto } from '~/api/contents';

type Props = {
  hubSlug: string;
  content: ContentDto;
};

const props = defineProps<Props>();

const contents = await apiGetContentsList(props.hubSlug, {
  page: 1,
  perPage: 1,
  type: [],
});
</script>
